<template>
    <div class="pageBox">
        <img :src="this.$store.state.backImg==null?'../assets/images/logo.png':this.$store.state.backImg"
             alt=""
             class="back">
        <div class="logonFrame">
            <div class="logonBox">
                <span class="title">ZAJC 中安检测</span>
                <span class="hello">欢迎登录中安商城!</span>
                <div class="passwordLoginBox">
                    <div class="passwordLogin">密码登录：</div>
                    <span class="borderBottom"></span>
                </div>
                <div class="categoryRow">
                    <div class="item_category">
                        <div class="titleRow">
                            <span>*</span>
                            <div class="titleText">手机号：</div>
                        </div>
                        <input type="number" placeholder="手机号" :class="{error:isShowTips1}"
                               @blur="isLegal($event,1),isNull($event,1)" v-model="phone1">
                        <div class="tipsBox">
                            <span class="tips" v-show="isShowTips1">{{ tips1 }}</span>
                        </div>
                        <div class="titleRow">
                            <span>*</span>
                            <div class="titleText">密码：</div>
                        </div>
                        <input type="password" placeholder="请输入登录密码" @blur="isLegal($event,3),isNull($event,3)"
                               v-model="pass" :class="{error:isShowTips3}">
                        <div class="tipsBox">
                            <span class="tips" v-show="isShowTips3">{{ tips3 }}</span>
                        </div>
                        <div class="titleRow">
                            <span>*</span>
                            <div class="titleText">验证码：</div>
                        </div>
                        <div class="verifyBox">
                            <input type="text" placeholder="请输入验证码(区分大小写)" :class="{error:isShowTips2}" class="verify"
                                   @blur="isLegal($event,2),isNull($event,2)"
                                   v-model="verify">
                            <div class="VerifyImg" @click="getVerify">
                                <img :src="verifyImg" alt="验证码"/>
                            </div>
                        </div>
                        <div class="tipsBox">
                            <span class="tips" v-show="isShowTips2">{{ tips2 }}</span>
                        </div>
                    </div>
                </div>
                <div @click="loginRequest" class="login btn">登录</div>
                <router-link to="/Register" class="register btn">注册账号</router-link>
                <div class="forget">
                    <div class="imgBox">
                        <img src="../assets/images/forget.png" alt="忘记密码">
                    </div>
                    <span>忘记密码?</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "login",
    data() {
        return {
            activeName: 'first',
            //手机号
            isShowTips1: false,
            isShowTips4: false,
            //验证码
            isShowTips2: false,
            // 密码
            isShowTips3: false,
            tips1: '',
            tips2: '',
            tips3: '',
            tips4: '',
            phone1: null,
            phone2: null,
            verify: null,
            pass: null,
            //是否获取验证码
            isGetVerify_On: false,
            //验证码路径
            verifyImg: '',
            verifyKey: '',
            verify_isGo: true,
            login_isGo: true,
        }
    },
    mounted() {
        document.title = '登录' + this.$suffix
        this.getVerify()
    },
    methods: {
        // handleClick(tab, event) {
        //     console.log(tab, event);
        // },

        /**
         * 获取验证码
         **/
        getVerify() {
            if (this.verify_isGo) {
                this.verify_isGo = false
                setTimeout(() => {
                    this.verify_isGo = true
                }, 1000)
                this.$get('/V1/VerifyCode/GetAuthCode', {})
                    .then((res) => {
                        // console.log('验证码', res)
                        this.verifyImg = res.response.img
                        this.verifyKey = res.response.key
                    })
                    .catch(() => {
                        this.$message.error("网络错误，请重试");
                    });
            } else {
                this.$message.error('请勿频繁刷新!')
            }
        },

        /**
         * 登录
         **/
        loginRequest() {

            if (this.phone1 == null || this.pass == null || this.verify == null
                || this.isShowTips1 == true || this.isShowTips2 == true || this.isShowTips3 == true) {
                this.$message.error('请规范输入!')
            } else {
                if (this.login_isGo) {
                    this.login_isGo = false
                    setTimeout(() => {
                        this.login_isGo = true
                    }, 2200)
                    this.$post('/V1/User/UserLogin', {
                        "userName": this.phone1,
                        "passWord": this.pass,
                        "code": this.verify,
                        "globalId": this.verifyKey
                    })
                        .then((res) => {
                            // console.log('登录', res)
                            if (res.success) {
                                this.$message.success('登录成功')
                                this.$setCookie('token', escape(res.response.token))
                                let tmp = {
                                    userAvatar: res.response.userAvatar,
                                    userName: res.response.userName,//id
                                    userPhone: res.response.userPhone
                                }
                                this.$store.commit('setUser', tmp)
                                this.$router.push('/')
                            } else {
                                this.$message.error(res.msg)
                            }
                        })
                        .catch(() => {
                            this.$message.error("网络错误，请重试");
                        });
                } else {
                    this.$message.error('请勿频繁请求登录!')
                }
            }
        },

        /**
         * 判空
         */
        isNull(e, index) {
            let isShow = false
            let tmp1 = null
            let tmp2 = '不能为空';
            if (e.target.value == '') {
                isShow = true
            }
            switch (index) {
                case 1:
                    tmp1 = '手机号'
                    this.tips1 = tmp1 + tmp2
                    this.isShowTips1 = isShow
                    break;
                case 2:
                    tmp1 = '验证码'
                    this.tips2 = tmp1 + tmp2
                    this.isShowTips2 = isShow
                    break;
                case 3:
                    tmp1 = '密码'
                    this.tips3 = tmp1 + tmp2
                    this.isShowTips3 = isShow
                    break;
                case 4:
                    tmp1 = '手机号'
                    this.tips4 = tmp1 + tmp2
                    this.isShowTips4 = isShow
                    break;
            }
        },

        /**
         * 输入是否合法
         */
        isLegal(e, index) {
            let isShow = false
            let tmp1 = null
            let tmp2 = '不规范';
            switch (index) {
                case 1:
                    if (e.target.value.length != 11 || !this.$isPhone(e.target.value)) {
                        isShow = true
                    }
                    if (e.target.value.length == 11 && this.$isPhone(e.target.value)) {
                        this.isGetVerify_On = true
                    }
                    tmp1 = '手机号'
                    this.tips1 = tmp1 + tmp2
                    this.isShowTips1 = isShow
                    break;
                case 2:
                    if (e.target.value.length != 4) {
                        isShow = true
                    }
                    tmp1 = '验证码'
                    this.tips2 = tmp1 + '4位，区分大小写'
                    this.isShowTips2 = isShow
                    break;
                case 3:
                    this.tips3 = '请输入8至16位英文和数字组合字符!'
                    if (e.target.value.length < 8 || e.target.value.length > 16) {
                        isShow = true
                    }
                    this.isShowTips3 = isShow
                    break;
                case 4:
                    if (e.target.value.length != 11 || !this.$isPhone(e.target.value)) {
                        isShow = true
                    }
                    // if (e.target.value.length == 11 && this.$isPhone(e.target.value)) {
                    //     this.isGetVerify_On = true
                    // }
                    tmp1 = '手机号'
                    this.tips4 = tmp1 + tmp2
                    this.isShowTips4 = isShow
                    break;
            }
        }
    }
}
</script>

<style scoped lang="less">
input::-webkit-outer-spin-button, input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

input[type="number"] {
    -moz-appearance: textfield;
}

::v-deep .el-tabs__item {
    font-size: 16px;
}

::v-deep .el-tabs__item.is-active {
    color: #333;
}

::v-deep .el-tabs__item:hover {
    color: #333;
}

::v-deep .el-tabs__active-bar {
    background-color: #1f2d5c;
    height: 4px;
    border-radius: 8px;
}

::v-deep .el-tabs__nav-wrap::after {
    background: transparent;
}

::v-deep .el-icon-arrow-left {
    color: #1f2d5c;
}

::v-deep .el-icon-arrow-right {
    color: #1f2d5c;
}

.pageBox {
    width: 100%;
    height: 800px;
    position: relative;
    background-color: #cccccc;

    .back {
        width: 100%;
        height: 100%;
    }

    .logonFrame {
        width: 1210px;
        margin: 0 auto;
        height: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;

        .logonBox {
            width: 450px;
            height: 580px;
            box-shadow: 0px 0px 6px 0px #cccccc;
            border-radius: 5px;
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: white;
            justify-content: center;

            .title {
                font-size: 35px;
                color: #1f2d5c;
                font-weight: bold;
            }

            .hello {
                font-size: 20px;
                color: #1f2d5c;
                margin: 10px 0px;
            }

            .passwordLoginBox {
                display: flex;
                flex-direction: column;
                width: 350px;

                .passwordLogin {
                    color: #1f2d5c;
                }

                .borderBottom {
                    height: 1px;
                    width: 70px;
                    border-radius: 100px;
                    border: 1px solid #1f2d5c;
                    background-color: #1f2d5c;
                    margin-top: 6px;
                    margin-bottom: 15px;
                }

            }

            .categoryRow {
                width: 350px;

                .item_category {
                    display: flex;
                    flex-direction: column;

                    .titleRow {
                        display: flex;
                        flex-direction: row;

                        span {
                            color: #F56C6C;
                        }

                        .titleText {
                            display: flex;
                            flex-direction: column;
                            font-size: 14px;
                            margin-left: 5px;
                        }
                    }

                    .error {
                        border: 1px solid #F56C6C;
                    }

                    .verifyBox {
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        align-items: center;

                        .verify {
                            width: 210px;
                            height: 40px;
                        }

                        .VerifyImg {
                            border: 1px solid #cccccc;
                            border-radius: 3px;
                            display: flex;
                            flex-direction: row;
                            justify-content: center;
                            align-items: center;
                            width: 80px;
                            height: 40px;
                            overflow: hidden;
                            cursor: pointer;

                            img {
                                max-width: 100%;
                                max-height: 100%;
                            }
                        }
                    }

                    input {
                        border: 1px solid #ccc;
                        border-radius: 3px;
                        outline: #1f2d5c;
                        padding: 0px 20px;
                        height: 50px;
                        font-size: 15px;
                    }

                    .tipsBox {
                        height: 16px;
                        min-height: 16px;
                        line-height: 13px;
                        margin-bottom: 5px;

                        .tips {
                            color: #F56C6C;
                            font-size: 12px;
                        }
                    }
                }
            }

            .btn {
                border: 1px solid #1f2d5c;
                border-radius: 3px;
                height: 46px;
                width: 350px;
                line-height: 46px;
                font-size: 14px;
                text-align: center;
                margin: 5px 0px;
                cursor: pointer;
            }

            .login {
                background-color: #1f2d5c;
                color: white;
            }

            .register {
                color: #1f2d5c;
            }

            .forget {
                display: flex;
                flex-direction: row;
                align-items: center;
                margin-top: 20px;
                cursor: pointer;
                display: none !important;

                .imgBox {
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    background-color: #1f2d5c;
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    margin-right: 5px;

                    img {
                        width: 13px;
                        height: 15px;
                    }
                }

                span {
                    color: #1f2d5c;
                    font-size: 14px;
                }

            }
        }
    }
}
</style>
